
    <form (formValid)="formValid.set($event)"
          (formDirty)="formDirty.set($event)">

        <div>
            <mat-form-field class="w-full">
                <mat-label>select manufacturer</mat-label>
                <mat-select (selectionChange)="onManufacturerChange($event)">
                    @for (manufacturer of vm.manufacturers; track manufacturer.value) {
                    <mat-option [value]="manufacturer.value">{{manufacturer.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        @if (vm.showRanges) {
        <div>
            <mat-form-field class="w-full">
                <mat-label>select range</mat-label>
                <mat-select (selectionChange)="onRangeChange($event)">
                    @for (range of vm.ranges; track range.value){
                    <mat-option [value]="range.value">{{range.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div> }


        @if (vm.showCables) {

        <div class="mce-form-field-group">

            <div>
                <mat-form-field class="width100">
                    <mat-label>select cable</mat-label>
                    <mat-select (selectionChange)="onCableChange($event)">
                        @for (cable of vm.cables; track cable.value){
                        <mat-option [value]="cable.value">{{cable.label}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            @if (vm.showCSAs) {
            <div>
                <mat-form-field class="width100">
                    <mat-label>select csa</mat-label>
                    <mat-select (selectionChange)="onCSAChange($event)">
                        @for (csa of vm.csas; track csa.value){
                        <mat-option [value]="csa.value">{{csa.label}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div> }

        </div> }

    </form>


@if (vm.showDatasheet) { <div [innerHTML]="vm.datasheet" class="view-datasheet-cables"></div> }

        @if (vm.showSpinner) {
<div class="spinner-center spinner-overlay">
    <mat-spinner test-id="spinner"></mat-spinner>
</div>   }

